module.exports = __webpack_public_path__ + "media/images/customer_service-73a9da335dffcdf5a8a461464bf21b58.png";